// extracted by mini-css-extract-plugin
module.exports = {"post-topics-wrapper":"styles_post-topics-wrapper__2vL5X","post-topics":"styles_post-topics__3ZC2M","topic":"styles_topic__1QM-N","add":"styles_add__2t807"};